import styled from '@emotion/styled';

const ValidationContainer = styled('div')({
  padding: '11rem 0 10rem',
});

export default ValidationContainer;
